import { COMPLETION_FRESHNESS_MS, type TimerCompletion } from '$lib/domain/timer';

const STORAGE_KEY = 'ff_consumed_notification_events';
const consumed = new Set<string>();
const MAX_EVENTS = 64;

// Consume before any asynchronous audio or platform call. A suppressed delivery
// is not retried on reload: prefer a missed sound to historical sound replay.
export const consumeNotificationEvent = (event: TimerCompletion, now = Date.now()) => {
  const age = now - event.scheduledAtMs;
  if (event.recovered || !Number.isFinite(age) || age < 0 || age > COMPLETION_FRESHNESS_MS) return false;
  try {
    const stored: unknown = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '[]');
    if (Array.isArray(stored)) {
      for (const id of stored.slice(-MAX_EVENTS)) if (typeof id === 'string') consumed.add(id);
    }
  } catch { /* In-memory deduplication still works if storage is unavailable. */ }
  if (consumed.has(event.eventId)) return false;
  consumed.add(event.eventId);
  while (consumed.size > MAX_EVENTS) consumed.delete(consumed.values().next().value!);
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify([...consumed])); } catch { /* Best effort. */ }
  return true;
};
